import { useCallback } from "react";
import { datadogRum } from "@datadog/browser-rum";

export type OnboardingEvent =
  | "onboarding_step_view"
  | "onboarding_skip"
  | "onboarding_import_click"
  | "onboarding_import_done"
  | "onboarding_import_failed";

// Each step's views, skips and import clicks, so the new onboarding can be
// compared with the old one. Sent to Datadog RUM as actions.
export const useOnboardingTracking = () =>
  useCallback(
    (event: OnboardingEvent, metadata: Record<string, string> = {}) => {
      try {
        datadogRum.addAction(event, metadata);
      } catch (error) {
        // Tracking must never break the onboarding.
        console.error("Datadog action error:", error);
      }
    },
    []
  );
